
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserRatingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserRating"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratingValue"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":92}};
    doc.loc.source = {"body":"fragment UserRatingFields on UserRating {\n  __typename\n  id\n  contentItemId\n  ratingValue\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
